import { useCallback, useEffect, useState } from 'react';
const useGetIsReportTagsTooBig = containerWidth => {
  const [allReportTagsWidth, setAllReportTagsWidth] = useState(0);
  const [firstReportTagWidth, setFirstReportTagWidth] = useState(0);
  const [isFirstReportTagTooBig, setIsFirstReportTagTooBig] = useState(true);
  const [isAllReportTagsTooBig, setIsAllReportTagsTooBig] = useState(true);
  const allReportTagsRef = useCallback(node => {
    if (node !== null) {
      setAllReportTagsWidth(node.getBoundingClientRect().width);
    }
  }, []);
  const firstReportTagRef = useCallback(node => {
    if (node !== null) {
      setFirstReportTagWidth(node.getBoundingClientRect().width);
    }
  }, []);
  useEffect(() => {
    if (containerWidth) {
      setIsAllReportTagsTooBig(allReportTagsWidth > containerWidth);
      setIsFirstReportTagTooBig(firstReportTagWidth > containerWidth);
    } else {
      setIsAllReportTagsTooBig(false);
      setIsFirstReportTagTooBig(false);
    }
  }, [allReportTagsWidth, containerWidth, firstReportTagWidth]);
  return {
    allReportTagsRef,
    firstReportTagRef,
    isFirstReportTagTooBig,
    isAllReportTagsTooBig
  };
};
export default useGetIsReportTagsTooBig;